import { Progress } from '@design-system';

interface QuestionnaireProgressProps {
  current: number;
  estimatedTotal: number;
}

export function QuestionnaireProgress({ current, estimatedTotal }: QuestionnaireProgressProps) {
  const safeTotal = Math.max(1, estimatedTotal);
  const percent = Math.min(100, Math.round((current / safeTotal) * 100));

  return (
    <div className="space-y-2">
      <p className="text-foreground text-xs font-medium uppercase tracking-wide">
        Question {current} of ~{safeTotal}
      </p>
      <Progress value={percent} />
    </div>
  );
}
